<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <div class="ibox">
                    <div class="ibox-content">
                        <form @submit.prevent="sendForm">
                            <div class="row">
                                <div class="col-4">
                                    <label class="fs-11px">szünetre/szünetről</label>
                                    <input type="text" class="form-control form-control-sm" v-model="add_form.lszsz_id" ref="lszsz_input"
                                        required @focus="$event.target.select()">
                                </div>
                                <div class="col-6">
                                    <label class="fs-11px">szünetről vissza státusza</label>
                                    <v-select class="border-0" v-model="add_form.status" :options="statuses"
                                        :reduce="option => option.id" label="name" :clearable="false" required>
                                    </v-select>
                                </div>
                                <div class="col-2">
                                    <button class="btn btn-primary" style="margin-top: 27px !important;">OK</button>
                                </div>
                            </div>
                            <div class="w-100 text-center" v-if="success">
                                <span class="badge bg-success">{{ success }}</span>
                            </div>
                        </form>
                        <hr class="mb-2">
                        <vue-good-table :columns="columns" :rows="rows" row-style-class="fs-10px" v-if="rows != null"
                            styleClass="vgt-table condensed bordered">
                        </vue-good-table>
                        <div class="w-100 text-center" v-else>
                            <i class="fa fa-cog fa-spin"></i>
                            <h5>Szünetek betöltése...</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import appService from '../../apis/appService';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

export default {
    components: {
        VueGoodTable,
    },
    data() {
        return {
            rows: null,
            columns: [
                {
                    label: 'Lszsz',
                    field: 'lszsz',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Név',
                    field: 'name',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Munkáltató',
                    field: 'employer',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Státusz',
                    field: 'status',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Szünet',
                    field: 'break',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Eddigi szünetei',
                    field: 'breaks',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
            ],
            add_form: {
                lszsz_id: null,
                status: 2
            },
            statuses: [
                { id: 2, name: 'rögzít' },
                { id: 20, name: 'ellenőriz' }
            ],
            success:null
        }
    },
    computed: {
        lszsz() {
            return this.$store.state.lszsz;
        },
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        this.getData();
        this.$store.commit('updateSubTitle', 'Szünetkezelés');
    },
    mounted() {
		this.$refs.lszsz_input.focus();
	},
    methods: {
        getData() {
            appService.getBreakList(this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
                this.rows = response.data;
            })
        },
        sendForm() {
            appService.setUserBreak(this.user.project_id, this.lszsz, appService.getDeviceId(),this.add_form.lszsz_id,this.add_form.status).then(response => {
                if(response.data.msg){
                    this.success = response.data.msg;
                }
                this.getData();
                this.add_form.lszsz_id = null;
                this.$refs.lszsz_input.focus();
            });
        }
    }
}
</script>